export default __webpack_public_path__ + "static/media/ots.3f38dae6.eot";